import { RouteConfig } from '@abaco/web-common/src/app';


const routes: RouteConfig[] = [
    {
        name: "iot-module-home",
        path: "/iot-module-home",
        component: () => import("./components/IotModuleContainerHome.vue"),
        meta: { navbarItems: [{component: 'farm-select-nav-bar-item', props: {isRequired: true}}, "campaign-select-nav-bar-item" ] }
    },
    {
        name: "deree-callback",
        path: "/iot-callback",
        component: () => import("./components/IotDereeCallbackPage.vue"),
        meta: {}
    },
    {
        name: "configure-iot",
        path: "/iot-configure/:sensor",
        component: () => import("./components/IotSingleTileContainerResponsive.vue"),
        props: route => ({tileId: "iot-accounts-form-tile", payload: route.params.sensor}),
        meta: {navbarItems: [{component: 'farm-select-nav-bar-item', props: {isRequired: true}}]}
    },
    {
        name: "agrirouter-callback",
        path: "/agrirouter-callback",
        component: () => import("./components/IotAgrirouterCallbackPage.vue"),
        meta: {}
    }
];

export default routes;
